import {
    LocalFeatureFlag,
    localFeatureFlagsAtom,
} from "@impero-com/common/utils/flipper";
import { useAtom } from "jotai";

import { OrganizationFeatureFlag } from "api/generated/model";

import { useFeatureFlagsQuery } from "../queries/useFeatureFlagsQuery";

export const useFeatureFlag = (
    flag: LocalFeatureFlag | OrganizationFeatureFlag
): boolean => {
    const { data } = useFeatureFlagsQuery();
    const [localFlags] = useAtom(localFeatureFlagsAtom);

    const remoteFlag = data[flag as OrganizationFeatureFlag];
    if (remoteFlag !== undefined) {
        return remoteFlag;
    }

    const isEnabled = localFlags[flag as LocalFeatureFlag];
    return isEnabled;
};
